<template>
    <div>
        <checkout-person ref="personData" :loginusername="loginusername"/>
        <checkout-payment ref="paymentType" :loginusername="loginusername" :settings="settings"/>

        <div class="uk-margin-medium uk-flex uk-flex-right">
            <button class="uk-button uk-button-default uk-margin-small-right" @click="back">
                {{ $t("Zurück") }}
            </button>
            <button class="uk-button uk-button-primary" @click="next">
                {{ $t("Weiter") }}
            </button>
        </div>
    </div>
</template>

<script>
import CheckoutPayment from "./CheckoutPayment";
import CheckoutPerson from "./CheckoutPerson";
import helper from "../../helper/helper";

export default {
    mixins: [helper],
    props: ["settings", "paymentOptionsForLabel", "loginusername"],
    components: {CheckoutPayment, CheckoutPerson },
    data: () => {
        return {
            couponErrorMsg: '',
            couponWrongProductMsg: ''
        }
    },
    mounted() {
        // The step is mounted again on every visit (v-if), so without the flag each
        // back-and-forth would count as a new checkout.
        if (this.store.state.checkoutTracked) {
            return;
        }
        this.store.state.checkoutTracked = true;
        this.store.commit("updateSession");
        const contents = Object.keys(this.store.state.selection).map(id => ({
            id,
            name: this.store.state.selection[id].ticket.name,
            quantity: this.store.state.selection[id].amount,
            price: this.store.state.selection[id].ticket.price,
        }));
        this.trackMetaPixel('InitiateCheckout', {
            content_ids: contents.map(c => c.id),
            content_type: 'ticket',
            num_items: contents.reduce((sum, c) => sum + c.quantity, 0),
            value: this.store.state.price,
            currency: 'EUR',
        });
        this.trackGA('begin_checkout', {
            currency: 'EUR',
            value: this.store.state.price,
            items: contents.map(c => ({
                item_id: c.id,
                item_name: c.name,
                price: c.price,
                quantity: c.quantity,
            })),
        });
    },
    methods: {
        async next() {
            if (await this.validate()) {
                this.checkCoupon()
                this.store.state.allDataCollected = true;
                this.$emit("next");
            } else {
                if (document.querySelector('.vf-input-group-danger')) {
                    window.setTimeout(() => this.$scrollTo('.vf-input-group-danger', 500, { offset: -120 }))
                }
                this.store.state.allDataCollected = false;
            }
        },
        back() {
            this.$emit("back", this.store.state.personalize && !this.store.state.onlyNoChipTicketsSelected ? 1 : 2);
        },
        async validate() {
            let valid = this.loginusername ? true : this.$refs.paymentType.validate();
            valid = await this.$refs.personData.validate() && valid;
            return valid;
        },
        checkCoupon() {
            this.couponErrorMsg = this.$t("Der eingegebene Gutschein-Code ist nicht gültig.")
            this.couponWrongProductMsg = this.$t("Der eingegebene Gutschein-Code erfordert ein anderes Produkt.")
            this.store.state.couponType = null
            this.store.state.couponValue = null
            this.store.state.couponOffers = []
            this.store.commit("updatePrice")
            if (this.store.state.couponSwitch && this.store.state.couponCode.length) {
                $.request("onCheckCouponCode", {
                    data: { code: this.store.state.couponCode},
                    success: (data) => {
                        if (!data.error) {
                            this.store.state.couponType = data.type
                            this.store.state.couponValue = data.value
                            this.store.state.couponOffers = data.offers || []
                            this.store.commit("updatePrice")
                            this.store.commit("updateSession")
                            if (!this.store.state.couponDiscount) {
                              if (data.offers) {
                                for (let offerId of data.offers) {
                                  if (typeof this.store.state.selection[offerId] != undefined) {
                                    return
                                  }
                                }
                              }
                              this.store.state.couponType = null
                              this.store.state.couponValue = null
                              this.store.state.couponOffers = []
                              UIkit.notification(this.couponWrongProductMsg)
                            }
                        } else {
                            UIkit.notification(this.couponErrorMsg)
                        }
                    }
                })
            }

        }
    },
};
</script>

<style lang="scss">
.invalid {
    input,
    .multiselect, .multiselect .multiselect__tags {
        transition: border-color 2s;
        border-color: #f34646 !important;
    }
}
</style>
